import React, { useEffect, useState } from "react";

// 12 phrases in Soul Femme brand voice, rotating to keep the user company
// while the reading is being assembled.
const PHRASES = [
  "You are not becoming someone new. You are recognising what has always been true.",
  "Your design does not need to be forced. It needs to be understood.",
  "You are not here to be reduced to labels. You are here to be read in layers.",
  "This is where your pattern becomes visible.",
  "Your power is not something you build. It is something you stop interrupting.",
  "Your desires are not distractions. They are directional.",
  "Depth is where everything changes.",
  "Once you see the pattern, you stop calling it a flaw.",
  "Your identity is not something you construct. It is something you return to.",
  "What you want is not random. It reflects what your system is designed to receive.",
  "Radiance is not performance. It is what becomes visible when your energy is uninterrupted.",
  "You don't learn this. You see it.",
];

const STAGES = [
  "Locating your Codex coordinates",
  "Reading the layers of your design",
  "Translating pattern into language",
  "Composing your transmission",
];

export const Loading = () => {
  const [phraseIdx, setPhraseIdx] = useState(0);
  const [stageIdx, setStageIdx] = useState(0);

  useEffect(() => {
    const phrase = setInterval(
      () => setPhraseIdx((s) => (s + 1) % PHRASES.length),
      4500
    );
    const stage = setInterval(
      () => setStageIdx((s) => (s + 1) % STAGES.length),
      6000
    );
    return () => {
      clearInterval(phrase);
      clearInterval(stage);
    };
  }, []);

  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      data-testid="loading-section"
    >
      <div className="portal-divider">
        <div className="portal-glow" />
        <div className="portal-ring" />
        <div className="portal-ring" />
        <div className="portal-ring" />
      </div>
      <div className="overline mt-8 mb-3" data-testid="loading-stage">
        {STAGES[stageIdx]}…
      </div>

      <div className="max-w-2xl px-4">
        <p
          key={phraseIdx}
          className="font-display italic text-2xl md:text-4xl leading-tight text-[var(--sf-ivory)] phrase-fade"
          data-testid="loading-phrase"
        >
          {PHRASES[phraseIdx]}
        </p>
      </div>

      <p className="codex-text mt-12 max-w-md text-sm">
        This takes 30–60 seconds. Stay here. The Codex is being written
        specifically for you.
      </p>
    </section>
  );
};

export default Loading;
